import styled from 'styled-components'

const MapStyle = styled.section`
	//! Map Height in AppHeader

	--catTitleMarginTop: var(--sp3x);
	--catTitleMarginBottom: var(--sp5x);

	--burgerIconSize: var(--sp6x);
	--burgerIconHeight: 3px;

	--infoWidth: var(--sp103x);
	--infoContWidth: var(--infoWidth);
	--infoContPadding: var(--sp5x);

	--markerIconContSize: var(--sp9x);
	--markerIconSize: 50%;
	--markerHoverContSize: var(--sp76x);
	--markerHoverContPadding: var(--sp2x);
	--markerHoverContTopPos: var(--sp2x);
	--markerHoverImageWidth: 43.28%;
	--markerHoverImageMarginRight: var(--sp4x);
	--markerHoverTitleMarginBottom: var(--sp2x);

	width: 100%;
	height: 100%;
	display: flex;
	flex: 1 1 auto;

	.cat-sec-title {
		margin-top: var(--catTitleMarginTop);
		margin-bottom: var(--catTitleMarginBottom);
	}

	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.TabletSizeSMin}) {
		.map-info-container,
		.burger-icon {
			animation: toVisible 0.3s 0.8s forwards;
			opacity: 0;
		}
	}

	.map-info-container {
		position: relative;
		width: var(--infoContWidth);
		min-width: var(--infoContWidth);
		min-height: 100%;
		max-height: 100%;
		z-index: 2;
		border-radius: 0px 10px 10px 0px;
		box-shadow: 3px 3px 3px var(--shadowColor);

		@keyframes toVisible {
			from {
				opacity: 0;
			}
			to {
				opacity: 1;
			}
		}

		.map-info-inner-container {
			position: relative;
			width: var(--infoContWidth);
			min-width: var(--infoContWidth);
			min-height: 100%;
			max-height: 100%;
			z-index: 2;
			border-radius: 0px 10px 10px 0px;
			overflow: hidden;

			> * {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				width: var(--infoWidth);
				padding: var(--infoContPadding);
				background: var(--primaryColor3);
				transform: translateX(-105%);
				transition: transform var(--trTime);
				box-shadow: 3px 3px 3px var(--shadowColor);
				border-radius: 0px 10px 10px 0px;
				overflow-x: hidden;
				overflow-y: scroll;
				/* -ms-overflow-style: none; */
				/* scrollbar-width: none;

                &::-webkit-scrollbar {
                    display: none;
                } */

				&.active {
					transform: translateX(0);
				}
			}
		}
	}

	&.closed {
		--infoContWidth: 0;

		.burger-icon {
			position: absolute;
			top: var(--sp1x);
			left: var(--sp1x);
			width: var(--burgerIconSize);
			background: var(--primaryColor3);
			z-index: 7;
			cursor: pointer;

			&:before {
				transform: translate(-50%, -50%) rotate(0);
				top: 35%;
			}

			&:after {
				transform: translate(-50%, -50%) rotate(0);
				top: 65%;
			}
		}
	}

	.burger-icon {
		position: absolute;
		top: var(--sp1x);
		left: calc(var(--infoContWidth) + var(--sp1x));
		width: var(--burgerIconSize);
		height: var(--burgerIconSize);
		z-index: 7;
		background: var(--secondaryColor3);
		border-radius: var(--sp1x);
		cursor: pointer;

		&:before,
		&:after {
			width: 50%;
			left: 50%;
			height: var(--burgerIconHeight);
			border-radius: 2px;
		}

		&:before {
			transform: translate(-50%, -50%) rotate(45deg);
		}

		&:after {
			transform: translate(-50%, -50%) rotate(-45deg);
		}
	}

	.mapboxgl-map {
		flex: 1;
		max-width: 100%;
		min-height: 100%;
		max-height: 100%;
		height: auto !important;

		.mapboxgl-canvas-container {
			.mapboxgl-canvas {
				width: 100% !important;
			}

			.mapboxgl-marker {
				.marker-container {
					position: relative;
					display: flex;
					align-items: center;
					justify-content: center;
					width: var(--markerIconContSize);
					height: var(--markerIconContSize);
					border-radius: 50%;

					> .imageCont {
						--imagePaddingTop: var(--markerIconSize);

						width: var(--markerIconSize);
					}

					.marker-icon {
						opacity: 1;
					}

					.marker-hover-icon {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						opacity: 0;
					}

					.marker-hover-cont {
						position: absolute;
						bottom: calc(100% + var(--markerHoverContTopPos));
						left: 50%;
						width: var(--markerHoverContSize);
						padding: var(--markerHoverContPadding);
						background: var(--primaryColor3);
						transform: translateX(-50%) translateZ(0);
						border-radius: var(--sp2x);
						overflow: hidden;

						.marker-hover-inner-cont {
							display: flex;
							align-items: center;

							.marker-hover-image {
								width: var(--markerHoverImageWidth);
								margin-right: var(--markerHoverImageMarginRight);

								.imageCont {
									--imagePaddingTop: 72.69%;

									border-radius: var(--sp2x);
									overflow: hidden;
									transform: translateZ(0);

									img {
										object-fit: cover !important;
									}
								}
							}

							.marker-hover-info {
								flex: 1;
								color: var(--primaryColor1);

								.marker-hover-title {
									margin-bottom: var(--markerHoverTitleMarginBottom);
								}
							}
						}
					}

					.marker-hover-triangle {
						position: absolute;
						bottom: 100%;
						left: 50%;
						transform: translateX(-50%);
						width: 0;
						height: 0;
						border-left: var(--sp2x) solid transparent;
						border-right: var(--sp2x) solid transparent;
						border-top: var(--sp2x) solid var(--primaryColor3);
					}

					.marker-hover-cont,
					.marker-hover-triangle {
						opacity: 0;
						transition: opacity var(--trTime);
						pointer-events: none;
					}
				}

				@media (hover: hover) {
					&:hover {
						z-index: 3;

						.marker-container {
							background: var(--primaryColor3);
							box-shadow: 0px 3px 32px #15233b3d;

							.marker-icon {
								opacity: 0;
							}

							.marker-hover-icon {
								opacity: 1;
							}

							.marker-hover-cont,
							.marker-hover-triangle {
								opacity: 1;
								pointer-events: all;
							}

							.marker-hover-cont {
								box-shadow: 0px 3px 32px #15233b3d;
							}
						}
					}
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXLMin}) {
		--catTitleMarginTop: var(--sp6x);
		--catTitleMarginBottom: var(--sp4x);

		--burgerIconSize: var(--sp5x);

		--infoWidth: var(--sp77x);
		--infoContWidth: var(--infoWidth);
		--infoContPadding: var(--sp4x);

		--markerIconContSize: var(--sp7x);
		--markerHoverContSize: var(--sp57x);
		--markerHoverContPadding: var(--sp1-5x);
		--markerHoverImageMarginRight: var(--sp3x);
		--markerHoverTitleMarginBottom: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeLMin}) {
		--catTitleMarginTop: var(--sp5x);
		--catTitleMarginBottom: var(--sp3x);

		--burgerIconSize: var(--sp4x);

		--infoWidth: var(--sp61x);
		--infoContWidth: var(--infoWidth);
		--infoContPadding: var(--sp3x);

		--markerIconContSize: var(--sp6x);
		--markerHoverContSize: var(--sp50x);
		--markerHoverContPadding: var(--sp1-5x);
		--markerHoverImageMarginRight: var(--sp2-5x);
		--markerHoverTitleMarginBottom: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeMMin}) {
		--catTitleMarginTop: var(--sp5x);
		--catTitleMarginBottom: var(--sp2-5x);

		--burgerIconSize: var(--sp4x);

		--infoWidth: var(--sp58x);
		--infoContWidth: var(--infoWidth);
		--infoContPadding: var(--sp3x);

		--markerIconContSize: var(--sp6x);
		--markerHoverContSize: var(--sp48x);
		--markerHoverContPadding: var(--sp1-5x);
		--markerHoverImageMarginRight: var(--sp2-5x);
		--markerHoverTitleMarginBottom: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeSMin}) {
		--catTitleMarginTop: var(--sp4x);
		--catTitleMarginBottom: var(--sp2-5x);

		--burgerIconSize: var(--sp4x);

		--infoWidth: var(--sp58x);
		--infoContWidth: var(--infoWidth);
		--infoContPadding: var(--sp3x);

		--markerIconContSize: var(--sp6x);
		--markerHoverContSize: var(--sp48x);
		--markerHoverContPadding: var(--sp1-5x);
		--markerHoverImageMarginRight: var(--sp2-5x);
		--markerHoverTitleMarginBottom: var(--sp2x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.DesktopSizeXSMin}) {
		--catTitleMarginTop: var(--sp1x);
		--catTitleMarginBottom: var(--sp2-5x);

		--burgerIconSize: var(--sp4x);

		--infoWidth: var(--sp51x);
		--infoContWidth: var(--infoWidth);
		--infoContPadding: var(--sp4x);

		--markerIconContSize: var(--sp6x);
		--markerHoverContSize: var(--sp43x);
		--markerHoverContPadding: var(--sp1x);
		--markerHoverImageMarginRight: var(--sp1-5x);
		--markerHoverTitleMarginBottom: var(--sp1x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeMin}) {
		--catTitleMarginTop: var(--sp1x);
		--catTitleMarginBottom: var(--sp2-5x);

		--burgerIconSize: var(--sp4x);

		--infoWidth: var(--sp80x);
		--infoContWidth: var(--infoWidth);
		--infoContPadding: var(--sp4x);

		--markerIconContSize: var(--sp6x);
		--markerHoverContSize: var(--sp43x);
		--markerHoverContPadding: var(--sp1x);
		--markerHoverImageMarginRight: var(--sp1-5x);
		--markerHoverTitleMarginBottom: var(--sp1x);
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.MobileSize}) and (max-width: ${({ theme }) =>
			theme.mediaQuery.TabletSizeSMin}) {
		--catTitleMarginTop: var(--sp1x);
		--catTitleMarginBottom: var(--sp2-5x);

		--burgerIconSize: var(--sp4x);
		--burgerIconHeight: 2px;

		--infoWidth: 100%;
		--infoContWidth: var(--infoWidth);
		--infoContPadding: var(--sp4x);

		--markerIconContSize: var(--sp6x);
		--markerHoverContSize: var(--sp43x);
		--markerHoverContPadding: var(--sp1x);
		--markerHoverImageMarginRight: var(--sp1-5x);
		--markerHoverTitleMarginBottom: var(--sp1x);

		.burger-icon {
			top: var(--sp1x);
			left: calc(var(--infoContWidth) - var(--infoContPadding) * 2);
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.MobileSizeMin}) {
		--catTitleMarginTop: var(--sp1x);
		--catTitleMarginBottom: var(--sp2-5x);

		--burgerIconSize: var(--sp4x);
		--burgerIconHeight: 2px;

		--infoWidth: 100%;
		--infoContWidth: var(--infoWidth);
		--infoContPadding: var(--sp3x);

		--markerIconContSize: var(--sp6x);
		--markerHoverContSize: var(--sp43x);
		--markerHoverContPadding: var(--sp1x);
		--markerHoverImageMarginRight: var(--sp1-5x);
		--markerHoverTitleMarginBottom: var(--sp1x);

		.burger-icon {
			top: var(--sp1x);
			left: calc(var(--infoContWidth) - var(--infoContPadding));
			transform: translateX(-100%);
		}

		&.closed .burger-icon {
			transform: translateX(0);
		}
	}

	@media only screen and (hover: none) and (max-height: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) and (orientation: landscape),
		(max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		.map-info-container > * {
			overflow-y: scroll;
			-ms-overflow-style: none;
			scrollbar-width: none;

			&::-webkit-scrollbar {
				display: none;
			}
		}
	}
`

export default MapStyle
